import { useUser } from '@/shared/hooks/useUser';
import { BaseLayout } from '@/components/layout';
import { LeadsCapturePageRoute } from './LeadsCapturePageRoute';

/**
 * Staff-only page that wraps the leads capture feature in BaseLayout.
 */
export function LeadsCapturePage() {
  const { user } = useUser();

  if (!user?.is_staff) {
    return (
      <BaseLayout>
        <div className="flex items-center justify-center min-h-[50vh]">
          <p className="text-gray-500">You don&apos;t have permission to view this page.</p>
        </div>
      </BaseLayout>
    );
  }

  return (
    <BaseLayout>
      <LeadsCapturePageRoute />
    </BaseLayout>
  );
}
